import { queryOptions } from '@tanstack/react-query';
import pino from 'pino';
import { z } from 'zod';

import { PaymentRepository } from '../repositories/paymentRepository';
import { TeamRepository } from '../repositories/teamRepository';

import { currenciesKeys } from './query-keys';

const logger = pino({ name: 'currenciesQuery' });

const CurrencySchema = z.array(z.enum(['GBP', 'USD']));
type Currency = z.infer<typeof CurrencySchema>;

const getCurrencies = async (teamId: string | undefined) => {
	const currencies: Currency = await (teamId
		? TeamRepository.getCurrencies(teamId)
		: PaymentRepository.getCurrencies());
	const result = CurrencySchema.safeParse(currencies);
	if (!result.success) {
		logger.error({ message: 'Validation for currencies failed', error: result.error });
		throw new Error('Validation for currencies failed');
	}
	return result.data;
};

export const getCurrenciesQuery = (teamId: string | undefined) => {
	return queryOptions({ queryKey: currenciesKeys.getCurrencies(teamId), queryFn: () => getCurrencies(teamId) });
};
